export default defineAppConfig({
  icon: {
    customize: (content: string, _name: string, prefix: string) => {
      if (prefix !== 'dddoodle')
        return content

      return content
        .replace(/stroke="(?!none")[^"]*"/g, `stroke="currentColor"`)
        .replace(/fill="(?!none")[^"]*"/g, `fill="currentColor"`)
    },
  },
})
